// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-v4a9","languageButtonsContainer":"styles_languageButtonsContainer__okpaD"};